// Shared chart styling for the stock details page (ApexCharts and ECharts).
import { theme } from "@/theme";

export const FONT = "Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif";

/**
 * A theme token (src/assets/theme.css) as a colour string charts understand:
 * the variables hold space-separated channels, which chart libraries can't parse.
 */
export function rgba(name, alpha = 1) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(`--qp-${name}`).trim();
    const [r, g, b] = raw.split(/\s+/).map(Number);
    if ([r, g, b].some((n) => !Number.isFinite(n))) return alpha >= 1 ? "rgb(0, 0, 0)" : `rgba(0, 0, 0, ${alpha})`;
    return alpha >= 1 ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Current theme colours. Reading `theme.isDark` makes a computed `options`
 * that calls this re-run (and the chart re-colour) when the theme changes.
 */
export function chartPalette() {
    const isDark = theme.isDark;
    return {
        isDark,
        ink: rgba("ink"),
        ink2: rgba("ink-2"),
        muted: rgba("muted"),
        faint: rgba("faint"),
        surface: rgba("surface"),
        line: rgba("line"),
        lineSoft: rgba("line-soft"),
        inverse: rgba("inverse"),
        inverseInk: rgba("inverse-ink"),
        accent: rgba("accent"),
        shadow: isDark ? "rgba(0,0,0,0.45)" : "rgba(15,23,42,0.10)",
    };
}

export function baseOptions() {
    const p = chartPalette();
    return {
        chart: {
            fontFamily: FONT,
            foreColor: p.muted,
            background: "transparent",
            toolbar: { show: false },
            zoom: { enabled: false },
            animations: { enabled: false },
        },
        grid: {
            borderColor: p.lineSoft,
            strokeDashArray: 4,
            padding: { left: 4, right: 4 },
        },
        dataLabels: { enabled: false },
        legend: {
            position: "bottom",
            horizontalAlign: "left",
            fontSize: "12px",
            fontFamily: FONT,
            markers: { size: 5, shape: "circle", strokeWidth: 0 },
            itemMargin: { horizontal: 10, vertical: 4 },
            clusterGroupedSeries: false,
        },
        tooltip: { theme: p.isDark ? "dark" : "light", style: { fontFamily: FONT, fontSize: "12px" } },
        noData: {
            text: "No data available",
            style: { color: p.faint, fontSize: "13px", fontFamily: FONT },
        },
    };
}
